import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

const HeaderPage = ({ title }) => {

  const navigate = useNavigate();

  const handleBackClick = () => {
    if (window.history.length > 2) {
      navigate(-1);  // Goes back in history
    } else {
      navigate('/');  // Navigate to the home page if no history
    }
  };

  return (
    <>

      <header
        className="header header-fixed style-3"
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -60, opacity: 0 }}
        transition={{ duration: 0.35, ease: "easeOut" }}
      >
        <div className="header-content gap-2">
          <div className="left-content">
            <a href="javascript:void(0);" onClick={handleBackClick} className="back-btn dz-icon icon-sm">
              <i className="fi fi-rs-angle-left" />
            </a>
          </div>
          <div className="mid-content">

            {title.length !== 0 ?
              <h5 className="title text-truncate" style={{ maxWidth: 300 }} >  {title} </h5>
              :
              <div
                className="card-1 skeleton"
                style={{ borderRadius: 5, height: 40, width: 180 }}
              ></div>
            }

          </div>
          <div className="right-content" />
        </div>
      </header>



    </>
  );
};

export default HeaderPage;
